import {
    GET_TEMP_PROPERTIES_BEGIN,
    GET_TEMP_PROPERTIES_SUCCESS,
    GET_TEMP_PROPERTIES_FAIL
  } from '../middleware/types'
  
  const initialState = {
    SUBMIT_loading: false,
    error: {},
    response:{}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case GET_TEMP_PROPERTIES_BEGIN:
        return {
          ...state,
          SUBMIT_loading: true
        }
      case GET_TEMP_PROPERTIES_SUCCESS:
          return {
              ...state,
              SUBMIT_loading: false,
              response: action.payload
            }
      case GET_TEMP_PROPERTIES_FAIL:
        return {
          ...state,
          SUBMIT_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }